import axios from "axios";
import { TTP_API_URL } from "Config";
import { throwCatchedError, updateSourceToken } from "Utils";

let getTeamSourceToken;

export const getTeam = ({
  token,
  limit,
  offset = 0,
  communityId,
  navCommunity,
  sourceToken = null
}) => {
  getTeamSourceToken = updateSourceToken(getTeamSourceToken, sourceToken);

  const fields = ["*", "avatar"];

  let requestUrl = `${TTP_API_URL}/organization/user`;

  const filter = [
    {
      property: "enabled",
      value: 1,
      operator: "eq"
    }
  ];

  if (communityId) {
    filter.push({
      property: "organization.id",
      value: communityId,
      operator: "eq"
    });
  } else if (navCommunity) {
    requestUrl += `?organization_id=${navCommunity.id}`;
  }
  // const sort = [
  //   {
  //     property: "createdAt",
  //     dir: "desc"
  //   }
  // ];

  return axios
    .get(requestUrl, {
      cancelToken: getTeamSourceToken.token,
      params: {
        access_token: token,
        filter: JSON.stringify(filter),
        //sort: JSON.stringify(sort),
        fields: fields.join(","),
        limit,
        start: offset
      }
    })
    .catch(function(thrown) {
      throwCatchedError(thrown);
    });
};

export const saveTeamSettings = ({ token, communityId, data }) => {
  const requestUrl = `${TTP_API_URL}/organization/organization-settings/save-team-preferences`;

  let formData = new FormData();
  formData.append("access_token", token);
  formData.append("data", JSON.stringify(data));
  formData.append("organization_id", communityId);

  return axios.post(requestUrl, formData);
};



// WEBPACK FOOTER //
// ./src/api/user.js